class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
    document.addEventListener('cartdrawer:opened', this.checkStickiness.bind(this));
    this.checkStickiness();
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {

        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          this.checkStickiness();
        }
      })
      .catch(e => {
        console.error(e);
      });
  }

  checkStickiness() {
    const main = this.closest('.mini-cart__main');
    if (!main) return;

    // Wait for a frame to ensure content is rendered and heights are correct
    requestAnimationFrame(() => {
      const recsHeight = this.offsetHeight;
      const itemsContainer = main.querySelector('cart-items');
      const itemsHeight = itemsContainer ? itemsContainer.offsetHeight : 0;
      const totalContentHeight = itemsHeight + recsHeight;
      const containerHeight = main.clientHeight;

      if (totalContentHeight <= containerHeight) {
        this.classList.add('is-sticky');
      } else {
        this.classList.remove('is-sticky');
      }
    });
  }
}
customElements.define('cart-recommendations', CartRecommendations);
